import React from 'react';
import { Info } from 'lucide-react';
import { dpiaLaws } from '../../data/dpiaLaws';
import type { PrivacyLaw } from '../../types';

interface DpiaLawSelectorProps {
  selectedLaws: string[];
  onLawsChange: (laws: string[]) => void;
}

export default function DpiaLawSelector({ selectedLaws, onLawsChange }: DpiaLawSelectorProps) {
  const handleLawChange = (lawId: string, checked: boolean) => {
    if (checked) {
      onLawsChange([...selectedLaws, lawId]);
    } else {
      onLawsChange(selectedLaws.filter(id => id !== lawId));
    }
  };

  return (
    <div className="bg-white p-6 rounded-lg shadow-sm mb-6">
      <div className="flex items-center justify-between mb-6">
        <h2 className="text-xl font-semibold">Select Applicable DPIA Requirements</h2>
        <div className="flex items-center text-sm text-gray-500">
          <Info className="w-4 h-4 mr-1" />
          <span>Hover for details</span>
        </div>
      </div>

      <div className="grid md:grid-cols-2 gap-6">
        {dpiaLaws.map((law) => (
          <div key={law.id} className="relative group">
            <div className="flex items-start p-4 border border-gray-200 rounded-lg hover:border-brand-primary transition-colors">
              <input
                type="checkbox"
                id={law.id}
                className="mt-1 rounded border-gray-300 text-brand-primary focus:ring-brand-primary"
                checked={selectedLaws.includes(law.id)}
                onChange={(e) => handleLawChange(law.id, e.target.checked)}
              />
              <label htmlFor={law.id} className="ml-3 cursor-pointer">
                <span className="block font-medium text-gray-900">{law.name}</span>
                <span className="block text-sm text-gray-500 mt-1">{law.description}</span>
              </label>
            </div>
          </div>
        ))}
      </div>

      <div className="mt-6 p-4 bg-emerald-50 rounded-lg">
        <p className="text-sm text-gray-600">
          Your DPIA will be customized based on the selected privacy laws and their specific requirements. 
          We'll ensure compliance with mandatory DPIA elements for each jurisdiction.
        </p>
      </div>
    </div>
  );
}